import {httpGetUserAvailability} from '@/features/users-availability/http/users-availability.http'
import {UserAvailability} from '@/features/users-availability/types'
import {QUERY_KEYS} from '@/queryClient'
import {useQueries} from '@tanstack/react-query'

export const useAvailabilitiesForMultipleTherapists = ({
    therapistIds,
    enabled
}: {
    therapistIds?: string[]
    enabled: boolean
}) => {
    const queries = useQueries({
        queries: (therapistIds || []).map(therapistId => ({
            queryKey: [QUERY_KEYS.USER_AVAILABILITY, therapistId],
            queryFn: () =>
                httpGetUserAvailability({
                    urlParams: {
                        userId: therapistId
                    }
                }),
            enabled: enabled && !!therapistId
        }))
    })

    return {
        queries,
        isLoading: queries.some(q => q.isLoading),
        isError: queries.some(q => q.isError),
        data: queries.map(q => q.data),
        // Create a map of therapistId to availability data
        availabilitiesMap: (therapistIds || []).reduce(
            (acc, therapistId, index) => {
                const availability = queries[index]?.data
                if (availability) {
                    acc[therapistId] = availability
                }
                return acc
            },
            {} as Record<string, UserAvailability>
        )
    }
}
